import { render, staticRenderFns } from "./single_permission.vue?vue&type=template&id=bdd702b6&scoped=true"
import script from "./single_permission.vue?vue&type=script&lang=js"
export * from "./single_permission.vue?vue&type=script&lang=js"
import style0 from "./single_permission.vue?vue&type=style&index=0&id=bdd702b6&prod&lang=scss&scoped=true"
import style1 from "./single_permission.vue?vue&type=style&index=1&id=bdd702b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd702b6",
  null
  
)

export default component.exports